export default {
    whatIsClick2Pay: 'Hva er Click to Pay',
    click2PayTitle: 'Click to Pay',
    click2PayChooseCardsTitle: 'Velg kortene du ønsker å legge til i Click to Pay',
    click2PayAdminDescription:
        'Her kan du administrere Click to Pay på kortene dine, samt endre kontaktinformasjonen din',
    click2PayLinkTitle: 'Nå kan du bruke Click to Pay fra Visa',
    click2PayLinkSubTitle: 'Netthandel gjort lekende lett',

    addCardToClick2Pay: 'Legg til kort i Click to Pay',
    click2PayGetGoing: 'Kom i gang',
    click2PayMaybeLater: 'Kanskje senere',
    click2PayNext: 'Neste',
    click2PayPrevious: 'Tilbake',
    click2PayEdit: 'Rediger',
    click2PayGoToHome: 'Til forsiden',

    click2PayChangeSettingsHere: 'Endre innstillinger her',
    click2PayAdminCardTitle: 'Kortene dine',
    click2PayAdminContactInfo: 'Kontaktinfo',

    click2PayActivate: 'Aktiver',
    click2PayCancel: 'Avbryt',
    click2PayUpdate: 'Oppdater e-post',
    click2PayEmailUpdated: 'E-post er oppdatert',
    click2PayRemove: 'Fjern dette kortet',
    click2PayRetryCard: 'Noe gikk galt, Prøv igjen',
    click2PayDeleteAccount: 'Ja, slett profil',
    click2payAccountDeleted: 'Profilen er slettet',
    click2payDeleteAccountVerification:
        'Ved å slette det siste kortet sletter du også Click to Pay-kontoen din. Er du sikker på at du vil fortsette?',

    click2PayGenericError: 'Noe gikk galt. Vennligst prøv igjen senere.',
    click2PayConsentText:
        'Ved å gjennomføre dette oppsettet, samtykker du til {} og er inneforstått med at Visa vil samle inn din private data, som ytterligere forklart i personvernserklæringen vår. Denne finner du i bunnen av siden.',
    click2PayInfoText:
        'Click to Pay er en digital lommebok som lar deg handle på nett uten å fylle ut kortdetaljer hver gang. Kort og kontaktinfo lagres én gang, og ved neste kjøp går betalingen med noen få klikk. ',
    click2PayLowAssuranceText:
        'Vi er nødt til å forsikre oss om at ingen forsøker å utgi seg for å være deg. Gjennom en enkel bildeverifisering får du tilgang til å bruke Click to Pay.',
};
